import React from 'react'
import { Create, TextInput, useTranslate, BooleanInput, TabbedForm, FormTab, useNotify, useRedirect, required, TabbedFormTabs } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { FieldArray } from './logic/ArrayInput'

export const ClientCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.client') }
    })
    redirect('/client')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.client') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_client')}>
        <TabbedForm tabs={<TabbedFormTabs variant="scrollable" scrollButtons="auto" />}>
          <FormTab label={translate('ra.entity.client')}>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.short_name')} required>
                <TextInput source='short_name' validate={[required()]} label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.long_name')}>
                <TextInput source='long_name' label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.is_active')}>
                <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
              </EditInputsWrap>
            </Grid>
          </FormTab>
          <FormTab label={translate('ra.entity.config_application')}>
            <FieldArray />
          </FormTab>
        </TabbedForm>
      </CardCommon>
    </Create>
  )
}
